import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {DOCUMENT_LIST} from '@/patient/routing/paths';

import DocumentList from '@/patient/views/document/DocumentList';

function DocumentListLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === DOCUMENT_LIST;
  return isRoot ? <DocumentList /> : <Outlet />;
}

export const Route = createFileRoute('/(patient)/documents')({
  component: DocumentListLayout
});
